export default {
  title: "Sistema Online CWS TECNOLOGIA"
};
